const { REACT_APP_INSIGHTS_URL = '' } = process.env

export const NAMESPACE = 'tpn'

const BASE = `${REACT_APP_INSIGHTS_URL}/reports/tpn`

// Served by le-go reporting-api. The agency comes from the bearer token.
// Writes are POST, never DELETE/PATCH: the Kong CORS plugin on /insights
// allows only GET and POST, so anything else dies in the browser preflight.
export const ENDPOINTS = {
  SETTINGS: `${BASE}/settings`,
  SETTINGS_REMOVE: `${BASE}/settings/remove`,
  SETTINGS_AUTO_SEND: `${BASE}/settings/auto-send`,
  SEND: `${BASE}/send`,
}

/** TPN's proposed upload windows (days of month). Shown next to the auto-send toggle. */
export const TPN_UPLOAD_SCHEDULE = '5th–7th, 10th–14th and 20th–25th of each month, with a catch-up on the 28th'

export const TPN_DATAWEB_URL = 'https://dataweb.tpn.co.za'
